export default {
  invalidEmail: 'Please enter valid E-mail address.',
  shouldAgreeWithPrivacy:
    'Your consent to the Terms and Conditions is required. Otherwise, you cannot register for the service.',
  eventNotExist: (eName) => `This "${eName}" event name (eName) doesn't exist. Please use right event name`,
  wrongLink: 'You are open a wrong link. Please open right link.',
  connectionError: 'Connection Error. Check your internet and try again.',
};
